<template>
  <div class="modal show fade modal-danger text-left" style="display: block;" v-show="show">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel120">Create Refund</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div style="max-width: 45%" class="mb-2">
            <span style="cursor: pointer;"><strong>Refund Status</strong>
            </span>
            <br>
            <span><small class="text-info">Total Transaction Amount</small> &nbsp; {{transactionAmount/100}}</span>
            <br>
            <span><small class="text-warning">Processed Refund Amount</small> &nbsp;{{processedRefundAmount/100}} </span>
            <br>
            <span><small class="text-primary">Hold Refund Amount</small>&nbsp; {{pendingRefundsAmount/100}} </span>
            <br>
            <hr class="my-50" style="border-top: 3px solid black" />
            <span><small class="text-success">Remaining Amount Available For Refund</small> &nbsp; {{remainingRefundAmount/100}} </span>
          </div>
          <hr class="my-50 "/>

          <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall"
                :initial-values="{isPartial: 0,description:'',amount:''}" ref="myForm">
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <div class="col-12 col-form-label">
                    <label>Amount</label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-group">
                      <Field
                          class="form-control"
                          type="text"
                          name="amount"
                          rules="decAmount"
                          :disabled="disableAmount"
                          :class="(errors.amount && !meta.valid && meta.touched)? 'is-invalid': ''"
                      >
                      </Field>
                    </div>
                    <ErrorMessage as="small" class="text-danger" name="amount"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12 col-form-label">
                    <label>Description</label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-group">
                      <Field
                          as="textarea"
                          class="form-control"
                          type="text"
                          name="description"
                      >
                      </Field>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                      <div class="custom-control custom-control-primary custom-checkbox">
                        <Field name="isPartial" type="checkbox" :value="1" v-model="isPartial"
                               class="custom-control-input" id="colorCheck1"/>
                        <label class="custom-control-label" for="colorCheck1">Partial</label>
                      </div>
                  </div>

                </div>
                <div class="form-group row d-flex justify-content-end">
                  <!--                    <button :ref="transactionId" style="display:none;" type="button">Submit</button>-->
                  <Button class="btn btn-primary mr-1" :loading="loader">Create</Button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!--        <div class="modal-footer justify-content-between">-->
        <!--          <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="$emit('hide')">Cancel</button>-->
        <!--          <button type="button" class="btn btn-gradient-success" @click="$emit('createRefund',transactionId)">Create</button>-->

        <!--        </div>-->
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

export default {
  props: ['show', 'transactionId','refundInitialAmount'],
  data() {
    return {
      list: [],
      isPartial: '',
      disableAmount:true,
      description: '',
      loader: false,
      transactionAmount:0,
      pendingRefundsAmount:0,
      processedRefundAmount:0,
      remainingRefundAmount:0,
    }
  },
  mounted() {
  },
  methods: {
    getTransactionsDetails() {
      let data = {
        transactionId: this.transactionId,
        refundAmountDetails:1,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transactions", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.transactionAmount = responseData.transactionAmount
                  this.processedRefundAmount = responseData.processedRefundAmount
                  this.pendingRefundsAmount = responseData.pendingRefundsAmount
                  this.remainingRefundAmount = responseData.remainingRefundAmount
                }

              }
            }
          }
      );
    },
    sendCall(values) {
      let data = {...values}
      if (typeof (data.isPartial) == 'undefined') {
        data.isPartial = 0;
      }
      data.amount = data.amount * 100
      data.transactionId = this.transactionId
      this.loader = true
      this.makeRequest('post', 'v1/create-refund-request', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.emitter.emit("refreshWallet", 'refresh')
            this.$router.push({name: 'refund-request'});
          }

          // this.$refs.myForm.setFieldValue('amount', '')
          // this.$refs.myForm.setFieldValue('amount', this.refundInitialAmount)
        }
        // this.$refs.myForm.setFieldValue('amount', '')
        // this.$refs.myForm.setFieldValue('amount', this.refundInitialAmount)

      });

    },
  },
  watch:{
    isPartial(val){
      if(val == 1){
        this.disableAmount = false
      }else{
        this.disableAmount = true
      }
    },
    show(val){
      if(!val){
        this.disableAmount = true
        this.$refs.myForm.setFieldValue('amount', '')
        this.$refs.myForm.setFieldValue('description', '')
        this.$refs.myForm.setFieldValue('isPartial', 0)
        this.transactionAmount=0
        this.pendingRefundsAmount=0
        this.processedRefundAmount=0
        this.remainingRefundAmount=0
      }else{
        this.getTransactionsDetails()
        this.$refs.myForm.setFieldValue('amount', this.refundInitialAmount)
      }

    }
  }
}
</script>

<style scoped>

/*--thank you pop starts here--*/
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}

.thank-you-pop h1 {
  font-size: 42px;
  margin-bottom: 25px;
  color: #5C5C5C;
}

.thank-you-pop p {
  font-size: 20px;
  margin-bottom: 27px;
  color: #5C5C5C;
}

.thank-you-pop h3.cupon-pop {
  font-size: 25px;
  margin-bottom: 40px;
  color: #222;
  display: inline-block;
  text-align: center;
  padding: 10px 20px;
  border: 2px dashed #222;
  clear: both;
  font-weight: normal;
}

.thank-you-pop h3.cupon-pop span {
  color: #03A9F4;
}

.thank-you-pop a {
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}

.thank-you-pop a i {
  margin-right: 5px;
  color: #fff;
}

#ignismyModal .modal-header {
  border: 0px;
}

/*--thank you pop ends here--*/

</style>

